import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { MatDialogRef } from '@angular/material/dialog';
import { UsuarioService } from '../../../services/usuario.service';

@Component({
  selector: 'app-excluir-cliente-dialog',
  templateUrl: './excluir-cliente-dialog.component.html',
  styleUrls: ['./excluir-cliente-dialog.component.scss', '../../../styles/estilo.padrao.scss']
})
export class ExcluirClienteDialog {
  bAutenticado: boolean = false;
  senhaMaster: string;
  uid;

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dialogRef: MatDialogRef<ExcluirClienteDialog>,
    private usuarioService: UsuarioService
  ) {
    this.uid = localStorage.getItem('uid');
  }

  confirmarExclusaoCliente() {
    this.dialogRef.close(true);
  }

  cancelar() {
    this.dialogRef.close();
  }

  autenticarSenha() {
    this.spinner.show('default');

    this.toastr.warning('Realizando autenticação', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

    this.usuarioService.validarSenhaMaster(this.senhaMaster).then(resp => {
      this.toastr.clear();
      if (resp) {
        this.bAutenticado = true;
      } else {
        this.bAutenticado = false;
        this.toastr.error('A senha informada não confere!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.senhaMaster = '';
        document.getElementById('input_senha_master').focus();
      }
      setTimeout(() => this.spinner.hide('default'), 150);
    }).catch(err => {
      this.toastr.clear();
      this.toastr.error('Houve um erro ao validar sua permissão! Tente novamente!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('default'), 300);

    })
  }

}
